import React, { useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function MeetOurExpertTeam() {
  const teamMembers = [{
    name: "Dr. Michael Flores, D.O.",
    position: "Board-Certified Physician | Founder, IronPeak Men's Health",
    bio: "I am a board-certified physician with over 10 years of medical experience. As a husband and father of three, I understand the importance of staying strong, healthy, and present for the people who matter most. Guided by strong Christian values, I treat every patient with honesty, compassion, and respect. My mission is simple: to help men reclaim their energy, confidence, and quality of life through safe, evidence-based care.",
    image: "https://relaxed-fowl.10web.cloud/wp-content/uploads/2025/09/Michael-Flores-scaled.jpg"
  }];
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);
  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/mfloresdo/30min'
      });
    }
  };
  return <section className="py-8 bg-background">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4 leading-snug">Meet Dr. Mike Flores</h2>
          <p className="text-base md:text-lg text-muted-dark leading-relaxed max-w-2xl mx-auto">Dr. Mike Flores is your physician — you'll work directly with him on your journey to better health.</p>
        </div>
        
        <div className="grid grid-cols-1 gap-8 max-w-5xl mx-auto">
          {teamMembers.map((member, index) => <div key={index} className="max-w-[38.88rem] mx-auto w-full">
              <Card className="card bg-white border border-muted-light shadow-soft hover:shadow-medium transition-all duration-medium hover-lift">
                <img src={member.image} alt={member.name} className="w-full h-64 object-cover object-[center_10%] rounded-t-xl" />
                <CardHeader>
                  <CardTitle className="text-xl md:text-2xl font-medium text-foreground leading-snug">
                    {member.name}
                  </CardTitle>
                  <CardDescription className="text-secondary font-medium text-base">
                    {member.position}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-base text-muted-dark leading-relaxed text-center">
                    {member.bio}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-12 max-w-3xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-semibold text-foreground mb-6 text-center leading-snug">
            What to Expect When You Get Started
          </h3>
          <ul className="space-y-3 text-base md:text-lg text-muted-dark leading-relaxed">
            <li className="flex items-start">
              <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
              <span>A comprehensive medical intake and consultation</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
              <span>Review of symptoms, history, and labs</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
              <span>Clear discussion of options and recommendations</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
              <span>Treatment only if appropriate</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
              <span>Ongoing follow-up and optimization</span>
            </li>
          </ul>
          <p className="mt-6 text-base md:text-lg text-muted-dark leading-relaxed text-center font-medium">
            No pressure. No sales tactics. Just medical guidance.
          </p>
          
          <div className="mt-8 bg-primary-light-bg border-2 border-primary rounded-md p-6">
            <h4 className="text-xl md:text-2xl font-semibold text-foreground mb-4 text-center leading-snug">
              Ready to Take the Next Step?
            </h4>
            <p className="text-base md:text-lg text-foreground leading-relaxed text-center mb-6">
              If something feels off—or you're not getting the results you should despite effort—the best place to start is a medical consultation.
            </p>
            <div className="flex flex-col items-center">
              <Button onClick={openCalendly} className="inline-flex items-center justify-center rounded-sm bg-accent text-accent-foreground px-6 py-3 h-12 font-semibold hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] cursor-pointer" type="button">
                Schedule a Consultation
              </Button>
              <p className="text-sm text-center text-muted-dark mt-3">
                Medical evaluation first. No pressure. Treatment only if appropriate.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}